module.exports = __webpack_public_path__ + "static/media/alert-light-red-on.2882e68a.png";